// extracted by mini-css-extract-plugin
export default {"applicationNotification":"ApplicationNotificationBar_applicationNotification__2BS76"};